import { mapGetters } from "vuex";

import rolesSettings from "../pages/roles/settings.js";
import rolesTabData from "../pages/roles/tabData.js";
import rolesActionSettings from "../pages/roles/actionSettings.js";
import rolesMainInfoSettings from "../pages/roles/mainInfoSettings.js";


import caseSettings from "../pages/cases/caseSettings.js";
import caseTabData from "../pages/cases/caseTabData.js";
import caseActionSettings from "../pages/cases/caseActionSettings.js";
import caseMainInfoSettings from "../pages/cases/caseMainInfoSettings.js";


import carSettings from "../pages/cars/carSettings.js";
import carTabData from "../pages/cars/carTabData.js";
import carActionSettings from "../pages/cars/carActionSettings.js";
import carMainInfoSettings from "../pages/cars/carMainInfoSettings.js";


import workOrderSettings from "../pages/workOrders/workOrderSettings.js";
import workOrderTabData from "../pages/workOrders/workOrderTabData.js";
import workOrderActionSettings from "../pages/workOrders/workOrderActionSettings.js";
import workOrderMainInfoSettings from "../pages/workOrders/workOrderMainInfoSettings.js";


import suSettings from "../pages/summons/suSettings.js";
import suTabData from "../pages/summons/suTabData.js";
import suActionSettings from "../pages/summons/suActionSettings.js";
import suMainInfoSettings from "../pages/summons/suMainInfoSettings.js";


export const settingsMixin = {
    data: function () {
        return {
            //this determins if there are any additional tab to display
            tabDatas: [
                {
                    subject: "roles",
                    data: rolesTabData
                },
                {
                    subject: "cases",
                    data: caseTabData
                },
                {
                    subject: "cars",
                    data: carTabData
                },
                {
                    subject: "su",
                    data: suTabData
                },
                {
                    subject: "wo",
                    data: workOrderTabData
                },

            ],
            //this determines what data to display in the table
            pageSettings: [
                {
                    subject: "roles",
                    settings: rolesSettings
                },
                {
                    subject: "cases",
                    settings: caseSettings
                },
                {
                    subject: "cars",
                    settings: carSettings
                },
                {
                    subject: "su",
                    settings: suSettings
                },
                {
                    subject: "wo",
                    settings: workOrderSettings
                },

            ],
            //this will display if there are any buttons and status information to show
            actionSettings: [
                {
                    subject: "cases",
                    columnNameToCheckStatus: "status",
                    settings: caseActionSettings
                },
                {
                    subject: "roles",
                    columnNameToCheckStatus: "name",
                    settings: rolesActionSettings
                },
                {
                    subject: "cars",
                    columnNameToCheckStatus: "status",
                    settings: carActionSettings
                },
                {
                    subject: "su",
                    columnNameToCheckStatus: "",
                    settings: suActionSettings
                },
                {
                    subject: "wo",
                    columnNameToCheckStatus: "",
                    settings: workOrderActionSettings
                },

            ],
            //this will display the main information record
            mainInfoSettings: [
                {
                    subject: "roles",
                    columnNameToCheckStatus: "name",
                    settings: rolesMainInfoSettings
                },
                {
                    subject: "cases",
                    columnNameToCheckStatus: "status",
                    settings: caseMainInfoSettings
                },
                {
                    subject: "cars",
                    columnNameToCheckStatus: "status",
                    settings: carMainInfoSettings
                },
                {
                    subject: "su",
                    columnNameToCheckStatus: "",
                    settings: suMainInfoSettings
                },
                {
                    subject: "wo",
                    columnNameToCheckStatus: "",
                    settings: workOrderMainInfoSettings
                },

            ],

        }
    },

    methods: {
        getSelectedSettingsValue(subject, key) {
            try {
                console.log("subject:", subject + " key:" + key);
                var filteredSettings = this.pageSettings.filter(f =>
                    f.subject == subject
                );
                console.log("filteredSettings:", filteredSettings);
                var tempData = "";
                console.log('approvalprocess:', filteredSettings[0].settings[0].gotApprovalProcess);
                if (filteredSettings[0].settings[0].gotApprovalProcess) {
                    tempData = _.find(filteredSettings[0].settings, function (o) {
                        return o['key'] == key;
                    });
                } else {
                    tempData = _.find(filteredSettings[0].settings, function (o) {
                        return true;
                    });
                }



                console.log('tempDatasss:', tempData);
                if (tempData != undefined && tempData != "") {
                    if (tempData.hasOwnProperty("tableSettings")) {
                        if (tempData.tableSettings.hasOwnProperty("filter")) {
                            if (tempData.tableSettings.filter.hasOwnProperty("userId")) {
                                tempData.tableSettings.filter.userId = this.getUserInfo.id;
                            }

                            if (tempData.tableSettings.filter.hasOwnProperty("userLink")) {
                                tempData.tableSettings.filter.userLink = this.getUserInfo.userLink;
                            }

                            if (tempData.tableSettings.filter.hasOwnProperty("branchId")) {
                                tempData.tableSettings.filter.branchId = this.getUserInfo.branch;
                            }

                            //for aditional data
                            if (tempData.tableSettings.hasOwnProperty("additionalData")) {
                                if (tempData.tableSettings.additionalData.hasOwnProperty("userId")) {
                                    tempData.tableSettings.additionalData.userId = this.getUserInfo.id;
                                }

                                if (tempData.tableSettings.additionalData.hasOwnProperty("userLink")) {
                                    tempData.tableSettings.additionalData.userLink = this.getUserInfo.userLink;
                                }

                                if (tempData.tableSettings.additionalData.hasOwnProperty("createdBy")) {

                                    tempData.tableSettings.additionalData.createdBy = this.getUserInfo.id;
                                }
                            }
                        }
                    }
                } else {
                    console.error(subject + " - " + key + " Has no Data!");
                    var data = [{ pageTitle: subject + " - " + key + " Has no Data!", tableSettings: null }];
                    return data;
                }
                return tempData;
            } catch (error) {
                console.log("error:", error);
                // this.$router.push({ name: 'page-error-404' });
            }

        },
        getActionSettings(subject, key) {
            try {
                console.log("subject==================:", subject);
                console.log("key==================:", subject);


                var filteredActionSettings = this.actionSettings.filter(f =>
                    f.subject == subject
                );




                console.log('filteredActionSettings:', filteredActionSettings);

                var tempData = _.filter(filteredActionSettings[0].settings, function (o) {
                    return o['key'] == key;
                });

                if (Object.entries(tempData).length > 1) {

                    var key = filteredActionSettings[0].columnNameToCheckStatus;
                    //if key is empty it means that this table does not need to check for status because it does not need
                    //we only check status when when filtering multiple record status
                    if (key != "") {
                        var currentStatus = this.getMainInfo[key];
                        tempData = _.find(tempData, function (o) {
                            return o['status'] == currentStatus;
                        });
                    }
                } else {
                    tempData = tempData[0];
                }

                //custom code for PR  ProcRejectedContract
                if (tempData.hasOwnProperty("status")) {
                    if (tempData.status == "HODRejectedContract" || tempData.status == "ProcRejectedContract" || tempData.status == "HOD Rejected Contract" || tempData.status == "Proc Rejected Contract" || tempData.status == "Rejected PR" || tempData.status == "Rejected Vendors" || tempData.status == "Rejected by Procurement" || tempData.status == "Rejected by HOD" || tempData.status == "PO Rejected By MD") {
                        if (this.getMainInfo.hasOwnProperty("reject_reason")) {
                            tempData.reject_reason = " Reason: " + this.getMainInfo['reject_reason']
                        } else if (this.getMainInfo.hasOwnProperty("rejectReason")) {

                            tempData.reject_reason = " Reason: " + this.getMainInfo['rejectReason']
                        }
                        else {
                            alert("Error: Rejected Object does not have rejected reason Field.");
                        }
                    }
                }



                //get the status of the current record  
                //we need to loop on Action button As well
                //for each button we need to defined the record ID to update when that buton is click
                //this record ID is defined when user click row of the table
                if (tempData.hasOwnProperty("actionButtons")) {
                    tempData.actionButtons.forEach(el => {
                        if (el.payLoad.hasOwnProperty("id")) {
                            el.payLoad.id = this.$store.state.profile.profileId
                        } else {
                            alert("pageStatus does not have id field")
                        }


                        if (el.hasOwnProperty("tableSettings")) {
                            console.log("dddddddddddddddddddddddddl:", el);
                            if (el.tableSettings.hasOwnProperty("additionalData")) {

                                if (el.tableSettings.additionalData.hasOwnProperty("createdBy")) {

                                    el.tableSettings.additionalData.createdBy = this.getUserInfo.id;
                                }

                                if (el.tableSettings.additionalData.hasOwnProperty("pkId")) {
                                    el.tableSettings.additionalData.pkId = this.$store.state.profile.profileId
                                }
                            }

                        }


                    });
                }



                return tempData;
            } catch (error) {
                console.log("error from getActionSettings:", error);
                // this.$router.push({ name: 'page-error-404' });
            }
        },
        getMainInfoSettings(subject, key) {
            try {
                var filteredmainInfoSettings = this.mainInfoSettings.filter(f =>
                    f.subject == subject
                );


                var tempData = _.filter(filteredmainInfoSettings[0].settings, function (o) {
                    return o['key'] == key;
                });

                if (Object.entries(tempData).length > 1) {
                    var key = filteredmainInfoSettings[0].columnNameToCheckStatus;
                    //if key is empty it means that this table does not need to check for status because it does not need
                    //we only check status when when filtering multiple record status
                    if (key != "") {
                        var currentStatus = this.getMainInfo[key];
                        console.log("currentStatus:", currentStatus);
                        tempData = _.find(tempData, function (o) {
                            return o['status'] == currentStatus;
                        });

                    }


                } else {
                    tempData = tempData[0];
                }


                //get the status of the current record  
                //we need to loop on Action button As well
                //for each button we need to defined the record ID to update when that buton is click
                //this record ID is defined when user click row of the table
                if (tempData != undefined) {
                    if (tempData.hasOwnProperty("actionButtons")) {
                        tempData.actionButtons.forEach(el => {
                            if (el.buttonType == "action") { //other type is relay which don't have this id
                                if (el.payLoad.hasOwnProperty("id")) {
                                    el.payLoad.id = this.$store.state.profile.profileId
                                } else {
                                    alert("payLoad does not have id field")
                                }
                            }

                        });
                    }
                }

                console.log("tempData in main info:", tempData);
                return tempData;
            } catch (error) {
                console.log("error from getMainInfoSettings:", error);
                // this.$router.push({ name: 'page-error-404' });
            }
        },

        getSettings(subject, key) {
            return this.getSelectedSettingsValue(subject, key);
        },
        getTabDatas(subject, viewOnly) {
            console.log("viewOnly:", viewOnly);
            var tabData = this.tabDatas.filter(f =>
                f.subject == subject
            ); 


            //loop through the data and update the filter id
            tabData[0].data.forEach(el => {

                console.log("this.$store.state.profile.profileId:", this.$store.state.profile.profileId);
                console.log("this.getUserInfo.id:", this.getUserInfo.id);

                if (el.hasOwnProperty("tableSettings")) {

                    if (el.tableSettings.hasOwnProperty("additionalData")) {

                        if (el.tableSettings.additionalData.hasOwnProperty("createdBy")) {
                            console.log("elllllllllllllllllllllllllllll:", el);
                            el.tableSettings.additionalData.createdBy = this.getUserInfo.id;
                        }



                        if (el.tableSettings.additionalData.hasOwnProperty("pkId")) {
                            el.tableSettings.additionalData.pkId = this.$store.state.profile.profileId
                        }
                    }
                    if (el.tableSettings.hasOwnProperty("filter")) {
                        if (el.tableSettings.filter.hasOwnProperty("pkId")) {
                            el.tableSettings.filter.pkId = this.$store.state.profile.profileId
                        } else {
                            alert("Tab Data filter does not have pkId ")
                        }


                        if (el.tableSettings.filter.hasOwnProperty("userLink")) {
                            el.tableSettings.filter.userLink = this.getUserInfo.userLink;
                        }
 
                        //if viewOnly is true we update some property 
                        console.log("viewOnly now:", viewOnly);
                        if (viewOnly === true && viewOnly !== undefined) {
                            console.log("herer");
                            el.tableSettings.showAddBtn = false;
                            el.tableSettings.showActionButton = false;
                            el.tableSettings.showEditBtn = false;
                        } else {
                            el.tableSettings.showAddBtn = el.tableSettings.showAddBtnDefault;
                            el.tableSettings.showActionButton = el.tableSettings.showActionButtonDefault;
                            el.tableSettings.showEditBtn = el.tableSettings.showEditBtnDefault;
                        }


                    }
                }

            });


            console.log("tabData in get tab Data:", tabData);
            return tabData[0].data;
        },
        getSearch(subject, viewOnly) {
            var search = this.searchSettings.filter(f =>
                f.subject == subject
            );

            //loop through the data and update the filter id 
            if (search[0] != undefined) {
                return search[0].data;
            }

            return {}

        }


    },
    computed: {
        ...mapGetters({
            getUserInfo: "auth/getUserInfo",
            getMainInfo: "profile/getMainInfo"
        }),
        testData() {
            return "sdfsdf";
        }, 
    },
}